export interface DeadlineAlertIdentity {
  id?: string;
  kind: string;
  daysLeft: number;
  chipLabel?: string;
}

export function deadlineAlertKey(alert: DeadlineAlertIdentity): string {
  return alert.id || alert.kind;
}

export function isInvoiceDeadlineAlert(alert: DeadlineAlertIdentity): boolean {
  return alert.kind === 'invoice' || alert.kind === 'invoice_overdue' || alert.id === 'invoice-overdue';
}

export function deadlineAlertChipLabel(alert: DeadlineAlertIdentity): string {
  if (alert.chipLabel) return alert.chipLabel;
  if (alert.daysLeft <= 0) return 'hoje';
  return `${alert.daysLeft}d`;
}
